import styled from "styled-components";

import { deviceType, PARTNER } from "@tm/isomorphic-utils";
import { H2TagStyle } from "@tm/ui-widgets/components";

export interface SeoContentStyleProps {
  pageTheme?: string;
}

export const SeoContentStyle = styled.section<SeoContentStyleProps>`
  background: #fff;
  width: 100%;
  z-index: 1;
  ${(p) =>
    p.pageTheme === PARTNER.GI &&
    `
    background: #EFF3F8;
    padding-bottom:80px;
    `}
  ${H2TagStyle} {
    width: 510px;
    @media ${deviceType.mobile} {
      width: 100%;
    }
  }
  ul {
    list-style: initial;
    padding-left: 30px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul {
    margin: 1em 0;
  }

  @media ${deviceType.mobile} {
    padding: 0 16px;
    ${(p) =>
      p.pageTheme === PARTNER.GI &&
      `
    background: #fff;
    padding-top:16px;
    `}
  }
`;
